import { DEFAULT_PRODUCT_FAMILY } from '../../constants/productFamily';
import * as actionType from './actionTypes';

const initialState = {
  selectedProduct: DEFAULT_PRODUCT_FAMILY,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.SET_SELECTED_PRODUCT:
      return { ...state, selectedProduct: action.payload };
    case actionType.RESET_SELECTED_PRODUCT:
      // Back to initialState rather than re-deriving the default, so the default
      // stays defined in exactly one place.
      return initialState;
    default:
      return state;
  }
};

export default reducer;
